// extracted by mini-css-extract-plugin
export default {"no_downloads":"NoDownloads_no_downloads__BEplp"};